import EuropeSlides from './Europe/Slides';
import USSlides from './America/US/Slides';
import CanadaSlides from './America/Canada/Slides';
import { COUNTRY } from '../../../../commons/CountryUtils';

const slides = {
    [COUNTRY.UK]: EuropeSlides,
    [COUNTRY.FRANCE]: EuropeSlides,
    [COUNTRY.SPAIN]: EuropeSlides,
    [COUNTRY.GERMANY]: EuropeSlides,
    [COUNTRY.SWITZERLAND]: EuropeSlides,
    [COUNTRY.BELGIUM]: EuropeSlides,
    [COUNTRY.US]: USSlides,
    [COUNTRY.CANADA]: CanadaSlides,
};

export const getSlidesByCountry = (country) => slides[country];
